var _defs, _sodipodiNamedview;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToddler({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 126.40613,
    height: 126.406,
    viewBox: "0 0 126.40613 126.406",
    sodipodidocname: "Toddler.ai",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,94.805 H 94.805 V 0 H 0 Z",
    id: "path14"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapepageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapegroupmode: "layer",
    inkscapelabel: "Toddler",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,126.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    clipPath: "url(#clipPath16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(64.216,71.135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -0.016 c -3.099,0 -6.012,-1.205 -8.204,-3.393 -2.186,-2.183 -3.391,-5.084 -3.392,-8.167 -10e-4,-3.085 1.206,-5.989 3.398,-8.179 2.197,-2.196 5.084,-3.394 8.207,-3.399 3.097,0.004 6.006,1.212 8.19,3.403 2.183,2.191 3.383,5.104 3.377,8.202 C 11.548,-5.182 6.362,-0.008 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(75.2316,48.5759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -2.938,-2.948 -6.852,-4.574 -11.018,-4.579 h -0.018 c -0.599,0 -1.191,0.044 -1.778,0.11 0.28,-2.156 0.568,-4.31 0.858,-6.42 0.221,-1.604 0.442,-3.208 0.657,-4.813 l 0.174,-1.293 c 0.191,-1.416 0.382,-2.832 0.552,-4.25 0.429,-3.59 -2.176,-6.986 -5.805,-7.57 -0.38,-0.061 -0.757,-0.091 -1.13,-0.091 -3.274,0 -6.176,2.282 -6.738,5.494 -0.326,1.864 -0.574,3.753 -0.815,5.579 -0.103,0.785 -0.207,1.57 -0.316,2.354 l -0.337,2.433 -7.686,-1.453 c 0.572,-1.169 1.135,-2.325 1.692,-3.484 1.1,-2.29 1.046,-4.701 -0.156,-6.972 -1.309,-2.474 -3.525,-3.85 -6.24,-3.874 -6.124,-0.053 -8.417,-0.048 -14.826,-0.005 -3.856,0.026 -7.116,3.246 -7.267,7.177 -0.158,4.098 2.873,7.602 6.757,7.81 1.829,0.097 2.313,0.111 2.994,0.102 l -1.574,3.259 c -1.444,2.992 -1.592,6.215 -0.415,9.076 1.156,2.811 3.474,4.955 6.526,6.037 5.803,2.057 11.209,3.86 16.527,5.513 0.913,0.283 1.842,0.445 2.772,0.511 -0.003,0.117 -0.017,0.232 -0.017,0.349 10e-4,4.153 1.622,8.058 4.565,10.997 2.947,2.942 6.864,4.562 11.03,4.562 h 0.021 C -2.45,26.548 4.528,19.583 4.544,11.034 4.552,6.867 2.938,2.948 0,0 m -4.947,40.33 c -22.922,12.637 -51.748,4.3 -64.386,-18.621 -12.638,-22.922 -4.3,-51.748 18.621,-64.386 22.922,-12.638 51.749,-4.301 64.386,18.621 12.638,22.922 4.301,51.748 -18.621,64.386",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "translate(60.1423,31.0456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -0.175,1.298 c -0.214,1.599 -0.434,3.199 -0.654,4.797 -0.363,2.632 -0.725,5.333 -1.066,8.03 -1.873,0.774 -3.594,1.918 -5.072,3.395 -1.899,1.897 -3.239,4.196 -3.958,6.7 -0.725,-0.028 -1.455,-0.144 -2.18,-0.369 -5.268,-1.638 -10.625,-3.425 -16.378,-5.464 -1.967,-0.697 -3.445,-2.042 -4.163,-3.788 -0.739,-1.796 -0.626,-3.861 0.318,-5.817 l 2.657,-5.501 c 0.068,-0.14 0.132,-0.288 0.208,-0.467 l 1.319,-3.034 h -3.839 c -1.056,-0.008 -1.65,-0.002 -2.095,0.003 -0.835,0.009 -1.089,0.011 -3.059,-0.094 -1.714,-0.092 -3.048,-1.734 -2.974,-3.662 0.069,-1.794 1.579,-3.319 3.297,-3.331 6.384,-0.043 8.668,-0.048 14.765,0.005 1.227,0.011 2.124,0.582 2.739,1.745 0.61,1.152 0.637,2.222 0.086,3.369 -0.643,1.338 -1.295,2.672 -1.958,4.027 l -2.022,4.146 16.965,3.207 0.913,-6.591 c 0.111,-0.794 0.216,-1.589 0.321,-2.385 0.234,-1.785 0.478,-3.631 0.789,-5.412 0.251,-1.434 1.728,-2.394 3.291,-2.143 1.513,0.244 2.644,1.685 2.469,3.147 C 0.377,-2.792 0.188,-1.396 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToddler);
export default __webpack_public_path__ + "static/media/toddler.ea91ae70136691c6122b0574ef68b254.svg";
export { ForwardRef as ReactComponent };